"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
var util_1 = require("@app/util");
var ga4_1 = require("@app/ga4");
var session_1 = require("@app/session");
var offerwall_1 = require("@app/offerwall");
var facebook_1 = require("@app/facebook");
/* predefined in weboack.plugins DefinePlugin */
var VERSION = ENV_VERSION;
var COOKIE_PREFIX = 'bi3tracking';
var Tracking = /** @class */ (function () {
    function Tracking(options) {
        console.log("Tracking init version ".concat(VERSION));
        this.initOptions(options);
        this.cookies = new util_1.Cookies(COOKIE_PREFIX);
        this.session = new session_1.Session(this.cookies);
        this.request = new util_1.Request(this.endpoint, this.session);
        this.offerwall = new offerwall_1.Offerwall(this.loc, this.linksSelector, this.session);
        this.cookies.set('version', VERSION);
        window.bicrmTracking = this;
    }
    Tracking.prototype.initOptions = function (options) {
        var endpoint = options.endpoint, loc = options.loc, _a = options.linksSelector, linksSelector = _a === void 0 ? '.trackurl' : _a;
        this.endpoint = endpoint;
        this.loc = loc;
        this.linksSelector = linksSelector;
    };
    Tracking.prototype.initGa4 = function (apiKey, measurementId) {
        this.ga4 = new ga4_1.Ga4(apiKey, measurementId);
    };
    // GETTERS
    Tracking.prototype.getGa4 = function () {
        var _a;
        return (_a = this.ga4) === null || _a === void 0 ? void 0 : _a.get();
    };
    Tracking.prototype.getUtm = function () {
        return this.session.getUtm();
    };
    Tracking.prototype.getGCLID = function () {
        return this.session.getGCLID();
    };
    Tracking.prototype.track = function (event, properties) {
        properties = __assign(__assign({}, properties), { url: window.location.href, clicks: this.session.getTracks(), navigator: window.navigator, resolution: {
                height: window.screen.availHeight || window.screen.height,
                width: window.screen.availWidth || window.screen.width,
            } });
        this.session.incrementTracks();
        this.request.track(event, properties).catch(function (err) {
            console.warn('Error tracking event', err);
        });
    };
    //// OFFERWALL 
    Tracking.prototype.trackOfferall = function () {
        this.offerwall.trackLinks();
        var self = this;
        this.offerwall.addClickEvent(function (e) {
            var _a;
            var offerId = (_a = e === null || e === void 0 ? void 0 : e.dataset) === null || _a === void 0 ? void 0 : _a.offer;
            var href = e === null || e === void 0 ? void 0 : e.href;
            self.track('offerwall-click', { offer: href, offerId: offerId });
        });
        this.offerwall.trackClicks();
    };
    // replace params in offers links used on offerwall page
    Tracking.prototype.doit = function () {
        this.trackOfferall();
    };
    Tracking.prototype.offerwallAddClickEvent = function (callback) {
        this.offerwall.addClickEvent(callback);
    };
    Tracking.prototype.offerwallTrackClick = function () {
        this.offerwall.trackClicks();
    };
    // get facebook pixel id from request params or cookies
    Tracking.prototype.addFacebookPixel = function () {
        var fbpx = this.session.getFacebookPixelId();
        if (!fbpx) {
            return;
        }
        var facebookPixel = new facebook_1.FacebookPixel(fbpx);
        facebookPixel.add();
    };
    return Tracking;
}());
exports.Tracking = Tracking;
